import React, { useCallback } from 'react';
import { DropDiv } from './styles';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE, SETTING_TEAMS_MENU_OPTION } from '../../../global/constants';
import Dropdown from '../../dropdown/mainDropdown';
import DropdownItem from '../../dropdown/dropdownItem';
import { MobxFilteredTasksListInterface } from '../../../interfaces/TaskInterface';
import { WorkspaceModel } from '../../../mobx/models/workspace';
import IconButton from '../../button/iconButton';

interface Props {
  groupDetail?: MobxFilteredTasksListInterface;
  loadData: () => void;
  workspaceDetail?: WorkspaceModel | null;
  collapseIds?: string[];
  setCollapse?: (value: string) => void;
}

const CollapseDropdown: React.FC<Props> = (props) => {
  const { groupDetail, collapseIds, setCollapse } = props;

  const collapse = useCallback(
    async (group: MobxFilteredTasksListInterface) => {
      if (setCollapse) setCollapse(String(group.id));
    },
    [setCollapse]
  );

  const handleClick = useCallback(
    (key: number | string) => {
      key = Number(key);
      if (key === SETTING_TEAMS_MENU_OPTION.ADMIN) {
        if (groupDetail) {
          collapse(groupDetail);
        }
      }
    },
    [collapse, groupDetail]
  );

  return (
    <DropDiv>
      <Dropdown
        modalTitle='Manage Group'
        activeClassName='active-state'
        content={
          <IconButton
            iconName='three-dots-horizontal-icon'
            size={ICON_BUTTON_SIZE.SMALL}
            variant={ICON_BUTTON_TYPE.TERTIARY}
          />
        }
        trigger='click'>
        <DropdownItem
          key={SETTING_TEAMS_MENU_OPTION.ADMIN}
          label={collapseIds?.includes(String(groupDetail?.id)) ? 'Expand Group' : 'Collapse Group'}
          onClick={() => handleClick(SETTING_TEAMS_MENU_OPTION.ADMIN)}
        />
      </Dropdown>
    </DropDiv>
  );
};

export default CollapseDropdown;
